import {
  getCongestionStyle,
  CongestionPopupTemplate,
} from "../../util/CongestionUtil";

const style = getCongestionStyle;

const module = {
  name: "Real Time Traffic",
  endpoint: "/realTimeTrafficMap.json",
  showOnMap: true,
  polylineLayer: true,
  style: style,
  congestionLayer: true,
  PopupTemplate: CongestionPopupTemplate,
  updateDelay: 180,
  mapLayerIcon: process.env.PUBLIC_URL + "Arterial_Congestion_v16.png",
  maxZoomArt: 13,
  maxZoomHwy: 7,
  zIndexHwy: 607,
  zIndexArt: 605,
};

export default module;
